module.exports = __webpack_public_path__ + "static/media/gear_icon.c50be6af.jpg";